const router = [];

export default router;



// WEBPACK FOOTER //
// ./src/router/trade.js